export const config = {
  hint: '请输入',
  slug: `attachment${Math.round(Math.random() * 100)}`,
  type: 'attachment',
  intro: '请选择要上传的文件',
  title: '文件',
  default: {},
  maxSize: 500,
  readonly: false,
  required: false,
  description: '备注显示区域：进行详细的解释说明。',
  allowedTypes: ['.doc', '.docx', '.pdf', '.xls', '.xlsx'],
  allowedAppImport: true,
  allowedWebImport: true,
  uploadQuantities: 20,
}
